import { Box, Typography } from '@mui/material'

import CloudflareImage from '@ecm/ui/element/CloudflareImage'
import Color from '@ecm/ui/element/Color'

type MetricProps = {
  bgColor?: string
  icon: string
  label: React.ReactNode
  unit?: string
  value: string
}

const Metric = ({ bgColor, icon, label, unit, value }: MetricProps) => (
  <Box bgcolor={bgColor} p="1em" textAlign="center">
    <CloudflareImage src={icon} />
    <Box color={Color.saint.normal}>
      <Typography
        display="inline"
        fontWeight={700}
        fontSize="3em"
        fontFamily='"Mulish", sans-serif'
      >
        {value}
      </Typography>

      {unit && (
        <Typography
          display="inline"
          fontWeight={800}
          fontSize="1.5em"
          fontFamily='"Mulish", sans-serif'
        >
          {unit}
        </Typography>
      )}
    </Box>
    <Typography variant="p3" textAlign="center" color={Color.saint.normal} mb="0">
      {label}
    </Typography>
  </Box>
)

export default Metric
